<template>
<div class="player-setup-videowall">
  <h2 class="text-[13px] font-semibold text-[#23569F] uppercase leading-[1.5]">{{ $t('playerSetup.Progress_Adjustments') }}</h2>
  <div class="grid">
      <div class="w-1/2 justify-self-center">
        <player-setup-form-error :message="externalError" :display="externalError != null && externalError != ''" height="minimal" />
      </div>
    </div>

  <span class="hidden grid-cols-2 grid-cols-3 grid-cols-4 bg-blue-200 border-black border-[#23569F]"></span>
  <el-form
    @submit.prevent="triggerFormSubmit"
      ref="refFormVideowall"
      :model="model"
      :rules="modelRules"
      class="common-form">
    <el-row>
      <el-col :span="11" class="relative z-10">
        <el-row class="flex-col mt-6">
          <h2 class="text-sm font-semibold text-[#000000] block">{{ $t("playerSetup.screenDiagonal") }}</h2>
          <el-row class="flex">
            <el-form-item prop="screenDiagonal" class="flex justify-center w-[100px]">
              <el-input tabindex="1" class="h-[30px] leading-[30px]" ref="screenDiagonal" v-model="model.screenDiagonal" @input="onModelChange"></el-input>
            </el-form-item>

            <PlayerSetupVideowallUnit
              ref="screenDiagonalUnit"
              :key="'screenDiagonalUnit'"
              :unit="model.screenDiagonalUnit"
              @change="onModelChange($event, 'screenDiagonalUnit')"
              ></PlayerSetupVideowallUnit>
          </el-row>
          <p class="text-xs input-hint text-start block mt-1">*{{$t('playerSetup.standardScreenOnly')}}</p>
        </el-row>

        <div class="mt-7 flex justify-between">
          <div v-if="showVerticalBezel" class="mr-[20px] vertical-bezel">
            <h2 class="text-sm font-semibold text-[#000000] block">{{ $t("playerSetup.VerticalBezel") }}</h2>
            <el-row class="flex">
              <el-form-item prop="verticalBezel" class="flex justify-center w-[100px]">
                <el-input
                  v-model="model.verticalBezel"
                  class="bezel"
                  tabindex="2"
                  @focus="isVerticalBezelFocus = true"
                  @blur="isVerticalBezelFocus = false"
                  @input="onModelChange"
                  ></el-input>
              </el-form-item>

              <PlayerSetupVideowallUnit
                ref="verticalBezelUnit"
                :key="'verticalBezelUnit'"
                :unit="model.bezelUnit"
                @change="onModelChange($event, 'bezelUnit')"></PlayerSetupVideowallUnit>
            </el-row>
          </div>

          <div v-if="showHorizontalBezel" class="horizontal-bezel">
            <h2 class="text-sm font-semibold text-[#000000] block">{{ $t("playerSetup.HorizontalBezel") }}</h2>
            <el-row class="flex">
              <el-form-item prop="horizontalBezel" class="flex justify-center w-[100px]">
                <el-input
                  v-model="model.horizontalBezel"
                  class="bezel"
                  tabindex="3"
                  @focus="isHorizontalBezelFocus = true"
                  @blur="isHorizontalBezelFocus = false"
                  @input="onModelChange"
                  ></el-input>
              </el-form-item>
              <PlayerSetupVideowallUnit
                ref="horizontalBezelUnit"
                :key="'horizontalBezelUnit'"
                :unit="model.bezelUnit"
                @change="onModelChange($event, 'bezelUnit')"></PlayerSetupVideowallUnit>
            </el-row>
          </div>
        </div>

        <div class="mt-10">
          <player-setup-canvas
            canvasType="videowall"
            :width="canvasWidth"
            :height="canvasHeight"
            @updateCanvasInfo="updateCanvasInfo"
            @canvasCheckInProgress="toggleCanvasCheckProgress"
          />
        </div>
      </el-col>
      <div :class="[gridWrapper, 'flex items-center justify-center']">
        <div :class="[gridProperty, 'grid gap-0', arrangement?.arrangement]">
          <!-- flex flex-col justify-end items-center -->
          <div
            v-for="item in tableData"
            :key="'output-' + item.label"
            class="border-black border grid text-xs outbox"
            :class="outputBoxProperty">
            <img
              :class="`preview-${displayOrientation} justify-self-center self-end`"
              :alt="displayOrientation">
            <div class="self-center justify-self-center"> {{ item.label }} </div>
          </div>
        </div>
      </div>
    </el-row>
  </el-form>
</div>
</template>

<script src="./player-setup-videowall.js"></script>
<style lang="scss" src="./player-setup-videowall.scss"></style>
